import { useLocale } from '../contexts/LocaleContext'
import { buildFindingReview, paragraphize, type FindingReview } from '../lib/findingReview'

type FindingLike = Parameters<typeof buildFindingReview>[0]

export function FindingReviewCard({
  finding,
  review,
}: {
  finding?: FindingLike
  review?: FindingReview
}) {
  const { t, locale } = useLocale()
  const data = review || (finding ? buildFindingReview(finding, locale) : null)
  if (!data) return null

  const blocks: Array<{ key: string; label: string; text: string; code?: boolean }> = [
    { key: 'what', label: t('review.what'), text: data.what },
    { key: 'why', label: t('review.why'), text: data.why },
    { key: 'where', label: t('review.where'), text: data.where },
    { key: 'snippet', label: t('review.snippet'), text: data.snippet, code: true },
    { key: 'fix', label: t('review.fix'), text: data.fix },
  ]

  return (
    <div className="finding-review" data-testid="finding-review">
      {blocks.map((block) => {
        if (!block.text) return null
        const paras = block.code ? [block.text] : paragraphize(block.text)
        return (
          <section key={block.key} className="finding-review-block">
            <h3>{block.label}</h3>
            {block.code ? (
              <pre>
                <code>{block.text}</code>
              </pre>
            ) : (
              paras.map((para, idx) => <p key={`${block.key}-${idx}`}>{para}</p>)
            )}
          </section>
        )
      })}
    </div>
  )
}
